const data = (data, empty = '') => {
  return data ?? empty;
}

export default data;